import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Label,
  InfoButton,
  Toggle,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEvent } from "react"
import { useCallback } from "react"

import styles from "./DayStats.module.scss"
import {
  usePolyglot,
  useFollowedUsers,
} from "src/contexts"
import { useInputPropsForValue } from "src/hooks"

const polyglotPrefix = "pages.settings.day_stats.hide_notes_history."
const id = "hide-note-toggle-btn"

interface Props {
  updatedAt?: string;
  updateDeviceSettings: (settings: Partial<DeviceSettings>) => void;
}

export function HideNotesHistory(props: Props) {
  const {
    updateDeviceSettings,
    updatedAt,
  } = props

  const polyglot = usePolyglot()
  const { currentDeviceSettings } = useFollowedUsers()
  const currentHideNotesHistory = currentDeviceSettings.hide_notes_history

  const adapter = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => e.target.checked,
    [],
  )

  const onValueChange = useCallback(
    (hideNotesHistory: DeviceSettings["hide_notes_history"]) => {
      updateDeviceSettings({
        hide_notes_history: hideNotesHistory,
      })
    },
    [updateDeviceSettings],
  )

  const {
    value,
    onChange,
  } = useInputPropsForValue({
    value: currentHideNotesHistory,
    onChange: onValueChange,
    adapter,
    updatedAt,
  })

  return (
    <div className={styles.toggleRow}>
      <Label htmlFor={id}>
        {polyglot.t(`${polyglotPrefix}label`)}
        <InfoButton title={polyglot.t(`${polyglotPrefix}title`)}>
          {polyglot.t(`${polyglotPrefix}description`)}
        </InfoButton>
      </Label>
      <Toggle
        id={id}
        checked={value}
        onChange={onChange}
      />
    </div>
  )
}
